import { IAppState } from '../../store';

export const selectRealtorVacancies = (state: IAppState) => state.vacancies;
